import { extendTheme } from '@chakra-ui/react'

    const breakpoints = {

        '1120px' : '1120px',

        '966px' : '966px',

        '836px' : '836px',

        '587px' : '587px',

        '934px' : '934px',

        '892px' : '892px',

        '798px' : '798px',

        '697px' : '697px',

        '806px' : '806px',

        '556px' : '556px',

        '457px' : '457px',

        '443px' : '443px',

        '379px' : '379px',

        '401px' : '401px',

        '359px' : '359px',

        '735px' : '735px',

        '612px' : '612px',

        '456px' : '456px',

        '486px' : '486px',

        '848px' : '848px',

        '685px' : '685px',

        '529px' : '529px',

        '410px' : '410px',

        '1349px' : '1349px',

        '1011px' : '1011px',

        '848px' : '848px',

        '496px' : '496px',

        '631px' : '631px',

        '555px' : '555px',

        '468px' : '468px',

        '363px' : '363px',

        '371px' : '371px',

        '358px' : '358px',

        '296px' : '296px',

    }

export const theme = extendTheme({ breakpoints, })